var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var Component = ref.Component;
var route = ref.route;
return [_c('transition',{attrs:{"name":route.meta.transition || 'fade'}},[_c(Component,{tag:"component"})],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }